import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../base/http.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SnackbarService } from '../../atom/snackbar/snackbar.service';
import { Meta, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class ContactComponent implements OnInit {
  public formGroup: FormGroup;
  constructor(
    private httpService: HttpService,
    private router: Router,
    public snackbarService: SnackbarService,
    private meta: Meta,
    private title: Title,
    private translate: TranslateService
  ) {
    this.createFormGroup();
  }
  public arrayPath: string[] = [];

  public createFormGroup() {
    this.formGroup = new FormGroup({
      name: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      comany_name: new FormControl('', [Validators.required]),
      content: new FormControl('', [Validators.required]),
    });
  }

  public isLoading = false;
  ngOnInit(): void {
    this.arrayPath = window.location.href.split('/');
    if (this.arrayPath[3] === 'jp' || this.arrayPath[4] === 'jp') {
      this.meta.addTag({
        name: 'description',
        content: '',
      });
      this.title.setTitle('日本医薬品 | お問い合わせ');
      this.translate.use('jp');
      this.translate.setDefaultLang('jp');
    } else {
      this.meta.addTag({
        name: 'description',
        content:
          'For inquiries about recruitment and business, please contact us using the dedicated form below.',
      });
      this.title.setTitle('JAPAN PHARMA INC. | contact');
      this.translate.use('en');
      this.translate.setDefaultLang('en');
    }
  }

  public onLoading(isLoading: any) {
    this.isLoading = isLoading;
  }

  public onAccept() {
    if (this.formGroup.valid) {
      this.httpService.post('contact', this.formGroup.value).subscribe(
        (value) => {
          if (value.stuats === 200) {
            if (this.arrayPath[3] === 'jp' || this.arrayPath[4] === 'jp') {
              this.router.navigate(['/complete/jp'], {
                queryParams: {
                  title: 'complate.title',
                  messege: `complate.messege`,
                },
              });
            } else {
              this.router.navigate(['/complete'], {
                queryParams: {
                  title: 'complate.title',
                  messege: `complate.messege`,
                },
              });
            }
          } else {
            // this.onError.e mit(value);
          }
        },
        (error) => console.log(error),
        () => console.log('onCompleted')
      );
    } else {
      this.snackbarService.pushValidationMessage();
    }
  }
}
